import { BaseWidget } from "./BaseWidget";

interface Props {
  value: number;
  compareValue: number;
  loading: boolean;
  currency: string;
}

export const NewCustomerRevenue = ({
  value,
  compareValue,
  loading,
  currency,
}: Props) => {
  return (
    <BaseWidget
      title="New Customer Revenue"
      value={value}
      compareValue={compareValue}
      loading={loading}
      downIsGood={false}
      subtitle="Revenue from new customers"
      valueFormatter={(value) =>
        value.toLocaleString("en-US", {
          style: "currency",
          currency: currency || "USD",
        })
      }
    />
  );
};
